const FakePlayer = () => {
  return <video />
}

export default FakePlayer
